if (typeof window.__printovaLockBodyScroll !== 'function') {
  window.__printovaLockBodyScroll = function () {
    document.body.style.overflow = 'hidden';
  };
  window.__printovaUnlockBodyScroll = function () {
    document.body.style.overflow = '';
  };
}
var lockBodyScroll = window.__printovaLockBodyScroll;
var unlockBodyScroll = window.__printovaUnlockBodyScroll;

if (!customElements.get('printova-crop-modal')) {
  class PrintovaCropModal extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.cloudName = this.dataset.cloudName || '';
      this.cropper = null;
      this.currentPhoto = null;
      this.onConfirmFn = null;
      this._lastFocus = null;

      this.innerHTML = `
        <div class="printova-crop-modal__backdrop" data-backdrop></div>
        <div class="printova-crop-modal__panel" role="dialog" aria-modal="true" aria-labelledby="printova-crop-title">
          <header class="printova-crop-modal__header">
            <h3 id="printova-crop-title">Crop your photo</h3>
            <button type="button" class="printova-crop-modal__close" data-close aria-label="Close">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path fill="currentColor" d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/>
              </svg>
            </button>
          </header>
          <div class="printova-crop-modal__body">
            <div class="printova-crop-modal__image-wrap">
              <img data-cropper-img alt="">
            </div>
            <div class="printova-crop-modal__loader" data-loader>
              <span class="printova-spinner"></span>
              <p>Loading photo…</p>
            </div>
            <p class="printova-crop-modal__hint">Drag the corners to adjust. The frame stays portrait A4.</p>
          </div>
          <footer class="printova-crop-modal__footer">
            <button type="button" class="printova-btn printova-btn--ghost" data-reset>Reset to auto</button>
            <div class="printova-crop-modal__footer-actions">
              <button type="button" class="printova-btn printova-btn--ghost" data-cancel>Cancel</button>
              <button type="button" class="printova-btn printova-btn--primary" data-confirm>Apply crop</button>
            </div>
          </footer>
        </div>
      `;

      this.backdrop = this.querySelector('[data-backdrop]');
      this.panel = this.querySelector('.printova-crop-modal__panel');
      this.img = this.querySelector('[data-cropper-img]');
      this.loader = this.querySelector('[data-loader]');
      this.closeBtn = this.querySelector('[data-close]');
      this.cancelBtn = this.querySelector('[data-cancel]');
      this.confirmBtn = this.querySelector('[data-confirm]');
      this.resetBtn = this.querySelector('[data-reset]');

      this.backdrop.addEventListener('click', () => this.close());
      this.closeBtn.addEventListener('click', () => this.close());
      this.cancelBtn.addEventListener('click', () => this.close());
      this.confirmBtn.addEventListener('click', () => this.applyAndClose());
      this.resetBtn.addEventListener('click', () => this.resetToAuto());

      this._onOrient = this.handleOrientationChange.bind(this);
      this._onResize = this.debounce(this.handleResize.bind(this), 150);
      this._onKey = this.handleKey.bind(this);
    }

    open({ photo, cloudName, onConfirm }) {
      if (typeof Cropper === 'undefined') {
        console.error('[printova] Cropper.js not loaded');
        return;
      }
      this.cloudName = cloudName || this.cloudName;
      this.currentPhoto = photo;
      this.onConfirmFn = onConfirm;
      this._lastFocus = document.activeElement;

      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
      }
      this.setAttribute('open', '');
      lockBodyScroll();
      this.loader.hidden = false;

      window.addEventListener('orientationchange', this._onOrient);
      window.addEventListener('resize', this._onResize);
      document.addEventListener('keydown', this._onKey);

      const workingUrl = `https://res.cloudinary.com/${this.cloudName}/image/upload/q_auto,f_auto,w_1200/${photo.publicId}`;

      this.img.onload = () => {
        this.loader.hidden = true;
        requestAnimationFrame(() => requestAnimationFrame(() => this.initCropper()));
      };
      this.img.onerror = () => {
        this.loader.hidden = true;
        this.loader.innerHTML = '<p>Could not load this photo. Close and try again.</p>';
        this.loader.hidden = false;
      };
      this.img.src = workingUrl;

      setTimeout(() => this.confirmBtn.focus(), 50);
    }

    initCropper() {
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
      const photo = this.currentPhoto;
      const self = this;
      this.cropper = new Cropper(this.img, {
        aspectRatio: 1 / 1.414,
        viewMode: 1,
        autoCropArea: 1,
        responsive: true,
        restore: true,
        dragMode: 'move',
        background: false,
        modal: true,
        guides: true,
        center: true,
        movable: true,
        zoomable: true,
        rotatable: false,
        scalable: false,
        toggleDragModeOnDblclick: false,
        ready() {
          if (photo.crop && !photo.crop.auto) {
            const naturalWidth = self.img.naturalWidth;
            const naturalHeight = self.img.naturalHeight;
            self.cropper.setData({
              x: photo.crop.x * naturalWidth,
              y: photo.crop.y * naturalHeight,
              width: photo.crop.width * naturalWidth,
              height: photo.crop.height * naturalHeight,
            });
          }
          requestAnimationFrame(() => {
            if (self.cropper) self.cropper.resize();
            requestAnimationFrame(() => {
              if (self.cropper) self.cropper.resize();
            });
          });
        },
      });
    }

    handleOrientationChange() {
      if (!this.cropper) return;
      const data = this.cropper.getData();
      setTimeout(() => {
        if (!this.cropper) return;
        this.cropper.setData(data);
      }, 250);
    }

    handleResize() {
      if (!this.cropper) return;
      const data = this.cropper.getData();
      this.cropper.setData(data);
    }

    handleKey(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
      }
    }

    applyAndClose() {
      if (!this.cropper || !this.currentPhoto) {
        this.close();
        return;
      }
      const data = this.cropper.getData();
      const naturalWidth = this.img.naturalWidth || 1;
      const naturalHeight = this.img.naturalHeight || 1;

      const clamp01 = (n) => Math.max(0, Math.min(1, n));
      const crop = {
        x: +clamp01(data.x / naturalWidth).toFixed(6),
        y: +clamp01(data.y / naturalHeight).toFixed(6),
        width: +clamp01(data.width / naturalWidth).toFixed(6),
        height: +clamp01(data.height / naturalHeight).toFixed(6),
        auto: false,
      };

      const fn = this.onConfirmFn;
      this.close();
      if (fn) fn(crop);
    }

    resetToAuto() {
      const fn = this.onConfirmFn;
      this.close();
      if (fn) fn({ x: 0, y: 0, width: 1, height: 1, auto: true });
    }

    close() {
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
      this.img.removeAttribute('src');
      this.removeAttribute('open');
      unlockBodyScroll();
      this.currentPhoto = null;
      this.onConfirmFn = null;
      window.removeEventListener('orientationchange', this._onOrient);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('keydown', this._onKey);
      if (this._lastFocus && typeof this._lastFocus.focus === 'function') {
        this._lastFocus.focus();
      }
    }

    debounce(fn, ms) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), ms);
      };
    }
  }

  customElements.define('printova-crop-modal', PrintovaCropModal);
}
